var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestsInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
    fill: "#EEEEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7955 22.4727H25.6364C24.9854 22.4727 24.3611 22.1969 23.9007 21.7059C23.4404 21.2149 23.1818 20.5489 23.1818 19.8545V12.2182C23.1818 12.1603 23.1603 12.1048 23.1219 12.0639C23.0835 12.023 23.0315 12 22.9773 12H18.2727C17.4047 12 16.5723 12.3678 15.9586 13.0225C15.3448 13.6771 15 14.5651 15 15.4909V32.9455C15 33.8713 15.3448 34.7592 15.9586 35.4139C16.5723 36.0686 17.4047 36.4364 18.2727 36.4364H29.7273C30.5953 36.4364 31.4277 36.0686 32.0414 35.4139C32.6552 34.7592 33 33.8713 33 32.9455V22.6909C33 22.633 32.9784 22.5775 32.9401 22.5366C32.9017 22.4957 32.8497 22.4727 32.7955 22.4727Z",
    fill: "#BF3B2B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3432 20.5419L24.9893 12.6977C24.975 12.6826 24.9568 12.6723 24.937 12.6681C24.9173 12.6639 24.8968 12.6661 24.8781 12.6743C24.8595 12.6825 24.8436 12.6964 24.8323 12.7143C24.8211 12.7321 24.815 12.7531 24.8149 12.7746V19.8552C24.8149 20.0867 24.9011 20.3086 25.0546 20.4723C25.208 20.636 25.4161 20.7279 25.6331 20.7279H32.2711C32.2913 20.7278 32.311 20.7214 32.3277 20.7094C32.3445 20.6974 32.3575 20.6804 32.3652 20.6605C32.3729 20.6406 32.3749 20.6188 32.371 20.5977C32.3671 20.5766 32.3575 20.5572 32.3432 20.5419V20.5419Z",
    fill: "#E0ABA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestsInactive);
export default __webpack_public_path__ + "static/media/requests-inactive.36f0eb0f81cc0e306c45e50066bf1ef2.svg";
export { ForwardRef as ReactComponent };